import React, { Component } from "react";
import { DataTable, ExportCSV } from "../../../../components";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { getStoreVisitor } from "../../../../store/dashboard/actions";
import { layout, roles, messages } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { Bar } from "react-chartjs-2";
import * as charts from "./_charts";
import * as columns from "./_columns";
import { selectStoreVisitorData } from "../../../../store/dashboard/selector";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Collapse,
  Label,
} from "reactstrap";
import { formatHelper } from "../../../../common/helpers";
import { getStoreVisitor as topStoreVisitorExport } from "../../../../service/dashboard";

import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcel } from "./excel";

class CardStoreVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStoreVisitor: true,
      startDate: null,
      endDate: null,
      loadingExport: false,
      selectedStore: null,
    };

    this.handleObtainStoreVisitorExport =
      this.handleObtainStoreVisitorExport.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;

    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getStoreVisitor({
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleStoreVisitorDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null && this.state.selectedStore) {
      this.props.getStoreVisitor({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.storeVisitors}
        keyField="id"
        columns={columns}
        loading={this.props.loading}
      />
    );
  }

  handleObtainStoreVisitorExport() {
    const { selectedStore, startDate, endDate } = this.state;
    topStoreVisitorExport(
      startDate ? startDate._d : null,
      endDate ? endDate._d : null,
      selectedStore.value
    ).then((response) => {
      exportExcel(
        response.data.data,
        selectedStore,
        startDate,
        endDate,
        this.props.role
      );
    });
  }

  render() {
    const { startDate, endDate } = this.state;
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showStoreVisitor: !this.state.showStoreVisitor })
          }
        >
          Top Visitas
        </CardHeader>
        <Collapse isOpen={this.state.showStoreVisitor}>
          <CardBody>
            <MediaQuery minDeviceWidth={layout.SM_MIN_WIDTH}>
              {(matches) => {
                if (matches) {
                  return (
                    <div>
                      {(this.props.role == roles.SUPER_ADMIN ||
                        this.props.role == roles.ADMIN) && (
                        <Row className="my-4">
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(this)}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                          <Col sm="1"></Col>
                          <Col sm="5"></Col>
                        </Row>
                      )}
                      <Row className="mb-2">
                        <Col sm="7">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDateStoreVisitor"
                            endDate={endDate}
                            endDateId="endDateStoreVisitor"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleStoreVisitorDateChange(
                                startDate,
                                endDate
                              )
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                            minimumNights={0}
                          />
                        </Col>
                        <Col sm="5">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={this.state.loadingExport}
                              exportCSV={this.handleObtainStoreVisitorExport}
                              minWidth={layout.SM_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      {(this.props.role == roles.SUPER_ADMIN ||
                        this.props.role == roles.ADMIN) && (
                        <Row className="my-4">
                          <Col sm="1">
                            <Label className="mt-2">Tienda:</Label>
                          </Col>
                          <Col sm="5">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingStores}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.stores}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleStoreChange.bind(this)}
                              value={this.state.selectedStore}
                              isDisabled={this.props.loadingStores}
                            />
                          </Col>
                          <Col sm="1"></Col>
                          <Col sm="5"></Col>
                        </Row>
                      )}
                      <Row className="mb-2">
                        <Col sm="5">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDateStoreVisitor"
                            endDate={endDate}
                            endDateId="endDateStoreVisitor"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleStoreVisitorDateChange(
                                startDate,
                                endDate
                              )
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                          />
                        </Col>
                        <Col sm="5">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={this.state.loadingExport}
                              exportCSV={this.handleObtainStoreVisitorExport}
                              minWidth={layout.SM_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <div>
                <Row>
                  <Col xl="7">
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                      {this.renderDataTable(columns.topStoreVisitorXS, false)}
                    </MediaQuery>
                    <MediaQuery
                      minWidth={layout.SM_MIN_WIDTH}
                      maxWidth={layout.MD_MAX_WIDTH}
                    >
                      {this.renderDataTable(columns.topStoreVisitor, false)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                      {this.renderDataTable(columns.topStoreVisitor, false)}
                    </MediaQuery>
                  </Col>
                  <Col xl="5">
                    <Bar
                      data={charts.topStoreVisitorData(
                        this.props.topStoreVisitorChartData
                      )}
                      options={charts.topStoreVisitorOptions()}
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { storeVisitors, total, error, loading } =
    state.dashboard.storeVisitorList;
  return {
    storeVisitors,
    total,
    error,
    loading,
    topStoreVisitorChartData: selectStoreVisitorData(state),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStoreVisitor,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardStoreVisitor);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopVisitors/CardTopVisitors.js